import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Form, Field } from 'react-final-form';
import { composeValidators, getQueryParam } from '../../../utils/helper';
import { required, isIfsc } from '../../../utils/validation';
import './EditNeft.scss';
import BootstrapSuccessError from './BootstrapSuccessError';
import { saveNeftValues } from '../../../actionCreators/myAccount';
// {"bankCode":"ICIC0001666","orderId":"1910062444","accountName":"xyz","accountType":"saving","returnId":"2030548","accountNumber":"A83398"}
// ^[A-Za-z]{4}[a-zA-Z0-9]{7}$

class EditNeft extends Component {
  constructor(props) {
    super(props);
    this.onNeftFormSubmit = this.onNeftFormSubmit.bind(this);
    this.orderId = getQueryParam(this.props.location.search.substr(1), 'order_id');
    this.returnId = getQueryParam(this.props.location.search.substr(1), 'return_id');
  }

  onNeftFormSubmit(values) {
    values.orderId = this.orderId;
    values.returnId = this.returnId;
    this.props.saveNeftValues(values);
  }

  renderField({ placeHolder, meta, input, type }) {
    return (
      <div className={meta.touched && meta.error ? 'has-error ' : ''}>
        <label className="control-label">{placeHolder}</label>
        <input className="form-control" {...input} autoComplete="off" type={type} />
        {meta.touched && meta.error && <div className="help-block with-errors">{meta.error}</div>}
      </div>
    );
  }

  render() {
    const { loading, editNeft, dataLocale } = this.props;
    const {
      SAVING,
      PARAMETER_MISSING,
      SYMBOL_ASTRIX,
      BANK_IFSC_CODE,
      SAVE_AND_CONTINUE,
      EDIT_ACCOUNT_INFORMATION,
      LKDOTCOM,
      NEFT_DETAILS,
      INFORMATION_UPDATE_SUCCESSFULLY,
      ACCOUNT_NUMBER,
      ACCOUNT_HOLDER_NAME,
      ACCOUNT_TYPE,
      SELECT,
      CURRENT,
    } = dataLocale;
    return (
      <div className="edit-neft">
        <Helmet title={LKDOTCOM} />
        <h2>{EDIT_ACCOUNT_INFORMATION}</h2>
        <h4>{NEFT_DETAILS}</h4>
        {Boolean(editNeft && editNeft.error) && (
          <BootstrapSuccessError message={editNeft.message} type="error" />
        )}
        {Boolean(editNeft && editNeft.result) && (
          <BootstrapSuccessError message={INFORMATION_UPDATE_SUCCESSFULLY} type="success" />
        )}
        {!this.orderId || !this.returnId ? (
          <BootstrapSuccessError message={PARAMETER_MISSING} type="error" />
        ) : (
          <Form
            noValidate
            autoComplete="off"
            autoCorrect="off"
            render={({ handleSubmit }) => {
              return (
                <form
                  className="display-flex flex-wrap flex-column"
                  style={{ width: '56%' }}
                  onSubmit={handleSubmit}
                >
                  <Field name="accountNumber" validate={composeValidators(required)}>
                    {({ input, meta }) =>
                      this.renderField({
                        placeHolder: `${ACCOUNT_NUMBER}${SYMBOL_ASTRIX}`,
                        meta,
                        input,
                        type: 'text',
                      })
                    }
                  </Field>
                  <Field name="accountName" validate={composeValidators(required)}>
                    {({ input, meta }) =>
                      this.renderField({
                        placeHolder: `${ACCOUNT_HOLDER_NAME}${SYMBOL_ASTRIX}`,
                        meta,
                        input,
                        type: 'text',
                      })
                    }
                  </Field>
                  <Field name="accountType" validate={composeValidators(required)}>
                    {({ input, meta }) => (
                      <div className={meta.touched && meta.error ? 'has-error ' : ''}>
                        <label className="control-label">{ACCOUNT_TYPE}</label>
                        <select className="form-control" {...input}>
                          <option value="">{SELECT}</option>
                          <option value="current">{CURRENT}</option>
                          <option value="saving">{SAVING}</option>
                        </select>
                      </div>
                    )}
                  </Field>
                  <Field name="bankCode" validate={composeValidators(required, isIfsc)}>
                    {({ input, meta }) =>
                      this.renderField({
                        placeHolder: `${BANK_IFSC_CODE}${SYMBOL_ASTRIX}`,
                        meta,
                        input,
                        type: 'text',
                      })
                    }
                  </Field>

                  <div className="margin-t20">
                    <div className="padding-t20" style={{ borderTop: '1px dashed #ccc' }}>
                      <button
                        className="btn-submit btn btn-primary col-sm-12"
                        disabled={loading}
                        type="submit"
                      >
                        {SAVE_AND_CONTINUE}
                      </button>
                    </div>
                  </div>
                </form>
              );
            }}
            onSubmit={this.onNeftFormSubmit}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  editNeft: state.myAccount.editNeft,
  dataLocale: state.locale,
});

function mapDispatchToProps(dispatch) {
  return {
    saveNeftValues: values => dispatch(saveNeftValues(values)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditNeft);
